//To find Robert's customizations, control+F for "Robert Customization"

let MetastockTemplate = function (
    target_html_id,
    template_source,
    template_description
) {
    let app = {
        compiled: false,
        target: false,
        init: function (target_html_id, template_source, template_description) {
            this.target = document.getElementById(target_html_id);

            if (!this.target) {
                throw new Error(
                    `Could not find the html element (${target_html_id}) ` +
                    `for ${template_description}`
                );
            }

            if (!template_source) {
                throw new Error('Could not find the template for ' + template_description);
            }

            this.compiled = template_source;
        },
        render: function (data) {
            if ('undefined' === typeof data) {
                data = {};
            }

            this.target.innerHTML = this.compiled(data);

            return true;
        }
    };

    app.init(target_html_id, template_source, template_description);

    return app;
};

let Metastock_Templates = {
    decide_quantity_line: function (available, quantity_selected) {
        if (0 == available) {
            return this.no_quantity();
        }

        return this.decide_available_quantity_line(available, quantity_selected);
    },
    decide_available_quantity_line: function (available, quantity_selected) {
        /* This function gets replaced during app init depending on whether
         * "Exact" or "Ranges" quantity tracking is used. */
    },
    no_quantity: function () {
        return {
            icon: Metastock_Templates.icon_unavailable(),
            text: 'En rupture de stock'
        };
    },
    exact_quantity: function (available, quantity_selected) {
        let available_data = {
            icon: Metastock_Templates.icon_available(),
            text: `${available} disponible(s)`
        };

        if (available < quantity_selected) {
            available_data.icon = Metastock_Templates.icon_unavailable();
        }

        return available_data;
    },
    ranges_quantity: function (available, low_stock_max) {
        let return_icon = Metastock_Templates.icon_available();
        let return_text = 'In Stock';

        if (available <= low_stock_max) {
            return_icon = Metastock_Templates.icon_low();
            return_text = 'Limited Stock';
        }

        return {
            icon: return_icon,
            text: return_text
        };
    }
};

Metastock_Templates.location = function (location) {
    let travel_time_html = '';
    if (location.travel_time) {
        travel_time_html = ` (<span>${location.travel_time}</span>)`;
    }

    let distance_html = '';
    if (location.distance) {
        distance_html = `<br><span>${location.distance}</span>${travel_time_html}`;
    }

    let offers_pickup = location.offers_pickup;

    let offers_delivery = location.offers_delivery;

    let display_location = location.metastock_enabled;

    let return_html = `
        <div class="flyout-selection-container">
            <h5 id="location-name">${location.name}</h5>
        </div>`;

    if (location.address || location.city) {
        return_html += `
            <div class="flyout-location-information">
                <p class="flyout-location">`;

        if (location.address) {
            return_html += `<span>${location.address}</span><br>`;
        }

        if (location.address2) {
            return_html += `<span>${location.address2}</span><br>`;
        }

        if (location.city) {
            return_html += `<span>${location.city}</span>`;

            if (location.state) {
                return_html += ', ';
            }
        }

        if (location.state) {
            return_html += `<span>${location.state}</span> `;
        }

        if (location.zip) {
            return_html += `<span>${location.zip}</span> `;
        }

        if (location.phone) {
            return_html += `<br><span>${location.phone}</span> `;
        }

        return_html += `${distance_html}</p></div>`;
    }

    // ✅ Retrieve metastockSettings from app embed
    let enablePickup = window.metastockSettings?.enable_pickup_locations ?? false;
    let enableDelivery = window.metastockSettings?.enable_delivery_locations ?? false;

    //If user is on the cart page.
    if (location.available === undefined) {

        if (enablePickup) {

            if (location.offers_pickup) {

                return_html += Metastock_Templates.pickup_available();

            } else {

                return_html += Metastock_Templates.pickup_unavailable();

            }

        }

        if (enableDelivery) {

            if (location.offers_delivery) {

                return_html += Metastock_Templates.delivery_available();

            } else {

                return_html += Metastock_Templates.delivery_unavailable();

            }

        }
        // Else user is on a product page with availability  
    } else {

        if (enablePickup) {

            //ROBERT ADDED PICKUP AND DELIVERY TO LOCATION FLYOUT
            if (location.offers_pickup == 1 && location.available > 0) {

                return_html += Metastock_Templates.pickup_available();

            } else {

                return_html += Metastock_Templates.pickup_unavailable();

            }

        }

        if (enableDelivery) {

            if (location.offers_delivery == 1 && location.available > 0) {

                return_html += Metastock_Templates.delivery_available();

            } else {

                return_html += Metastock_Templates.delivery_unavailable();

            }

        }

    }

    let available_data = Metastock_Templates.decide_quantity_line(location.available);

    if (location.selected) {
        return_html += `
            <button id="flyout-store-select"
                class="metastock-store-select-button-disabled button button--disabled"
                disabled
            >
                Votre magasin préféré
            </button>`;
    }
    else {
        return_html += `
            <button id="flyout-store-select"
                class="metastock-store-select-button button"
                onclick="MetastockFlyout.selectLocation(${location.id})"
            >
                Définir comme votre magasin préféré
            </button>`;
    }

    if (location.has_inventory) {
        let available_data = Metastock_Templates.decide_quantity_line(location.available);

        return_html += `
            <div class="metastock-flyout-location-availability-container">
                ${available_data.icon}
                <p class="metastock-flyout-location-availability">
                    ${available_data.text}
                </p>
            </div>
        `;
    }

    return return_html;
};

Metastock_Templates.location_list = function (data) {
    let return_html = '<ul id="js-menu-list">';

    data.locations.forEach(location => {
        if (location.metastock_enabled) {
            return_html += `
            <li>
                ${Metastock_Templates.location(location)}
            </li>`;
        }
    });

    return_html += '</ul>';

    return return_html;
};

Metastock_Templates.store_availability = function (data) {
    if (
        'undefined' !== typeof data.locations
    ) {
        return Metastock_Templates.all_store_availability(data)
    }
    else if (
        'undefined' !== typeof data.location
    ) {
        return Metastock_Templates.single_store_availability(data)
    }
}

Metastock_Templates.single_store_availability = function (data) {
    let return_html = '<div class="metastock-pdp-information">';

    return_html += `${Metastock_Templates.store_availability_line(data)}`;

    return_html += `
        <button id="drawer-btn"
            onclick="MetastockFlyout.open()" type="button"
            class="metastock-pdp-information-button metastock-pdp-small-text"
        >
            Vérifiez d'autres magasins
        </button>`;

    return_html += '</div>';

    // ✅ Retrieve metastockSettings from app embed
    let enablePickup = window.metastockSettings?.enable_pickup_locations ?? false;
    let enableDelivery = window.metastockSettings?.enable_delivery_locations ?? false;

    if (enablePickup) {

        return_html += `<div class="location-offers-pickup">`;

        if (data.offers_pickup == 1 && data.available > 0) {
            return_html += Metastock_Templates.pickup_available();
        } else {
            return_html += Metastock_Templates.pickup_unavailable();
        }

        return_html += '</div>';

    }

    if (enableDelivery) {

        return_html += `<div class="location-offers-delivery">`;

        if (data.offers_delivery == 1 && data.available > 0) {
            return_html += Metastock_Templates.delivery_available();
        } else {
            return_html += Metastock_Templates.delivery_unavailable();
        }

        return_html += '</div>';

    }

    return return_html;
};

Metastock_Templates.all_store_availability = function (data) {
    let return_html = '<div class="metastock-pdp-information"><ul class="metastock-pdp-location-inventory">';

    data.locations.forEach(location => {
        location.quantity = data.quantity;
        return_html += `<li>${Metastock_Templates.store_availability_line(location)}</li>`;
    });

    return_html += '</ul></div>';

    return return_html;
}

Metastock_Templates.store_availability_line = function (data) {
    let location_name = false;
    if (data.name || 'undefined' !== typeof data.name) {
        location_name = data.name;
    } else if (data.location || 'undefined' !== typeof data.location) {
        location_name = data.location;
    }


    let number_available = data.available;
    let quantity_selected = data.quantity;
    let offers_pickup = data.offers_pickup;
    let offers_delivery = data.offers_delivery;

    let return_html = '';

    //Make sure negative quantities are not displayed as in stock
    if (typeof number_available === 'number' && number_available > 0) {
        let available_data = Metastock_Templates.decide_quantity_line(
            number_available,
            quantity_selected
        );

        return_html += `
            ${available_data.icon}
            <p id="availability-info" class="metastock-pdp-information-title">
                ${available_data.text}`;
    }
    else {
        let no_stock = Metastock_Templates.no_quantity();

        return_html += no_stock.icon;

        return_html += `<p id="unavailable-title">${no_stock.text}`;
    }

    if (location_name) {
        return_html += ` à ${location_name}`
    }

    return_html += `</p>`;

    return return_html;
}

Metastock_Templates.icon_available = function () {
    return `<svg id="in-stock" aria-hidden="true" focusable="false" role="presentation" class="metastock-icon metastock-icon-in-stock" viewBox="0 0 12 10">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.293 9.707l-3-3a.999.999 0 1 1 1.414-1.414l2.236 2.236 6.298-7.18a.999.999 0 1 1 1.518 1.3l-7 8a1 1 0 0 1-.72.35 1.017 1.017 0 0 1-.746-.292z" fill="#00730B"></path>
        </svg>`;
};

Metastock_Templates.icon_low = function () {
    return `<svg id="in-stock" aria-hidden="true" focusable="false" role="presentation" class="metastock-icon metastock-icon-in-stock" viewBox="0 0 12 10">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.293 9.707l-3-3a.999.999 0 1 1 1.414-1.414l2.236 2.236 6.298-7.18a.999.999 0 1 1 1.518 1.3l-7 8a1 1 0 0 1-.72.35 1.017 1.017 0 0 1-.746-.292z" fill="#EFB219"></path>
        </svg>`;
};

Metastock_Templates.icon_unavailable = function () {
    return `<svg id="out-of-stock-variant" aria-hidden="true" focusable="false" role="presentation" class="metastock-icon metastock-icon-out-of-stock" viewBox="0 0 12 13">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.414 6.5l4.293-4.293A.999.999 0 1 0 10.293.793L6 5.086 1.707.793A.999.999 0 1 0 .293 2.207L4.586 6.5.293 10.793a.999.999 0 1 0 1.414 1.414L6 7.914l4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L7.414 6.5z" fill="#DD2200"></path>
        </svg>`;
};

//ROBERT ADDED TEMPLATES FOR DELIVERY & PICKUP
Metastock_Templates.pickup_available = function () {
    return `<p class="pickup-available">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="pickup-icon">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.015a3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z" />
                </svg>
                Pickup Available
            </p>`;
};

Metastock_Templates.pickup_unavailable = function () {
    return `<p class="pickup-unavailable">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="pickup-icon">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.015a3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z" />
                </svg>
                Pickup Unavailable
            </p>`;
};

Metastock_Templates.delivery_available = function () {
    return `<p class="delivery-available">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="delivery-icon">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
                </svg>
                Delivery Available 
            </p>`;
};

Metastock_Templates.delivery_unavailable = function () {
    return `<p class="delivery-unavailable">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="delivery-icon">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
                </svg>
                Delivery Unavailable 
            </p>`;
};

let metastock_template_location_list = Metastock_Templates.location_list;
let metastock_template_store_availability = Metastock_Templates.store_availability;

let MetastockStorage = (function () {
    let defaults = {
        address: '',
        locations_distances: false,
        location_id: false
    };

    let storage_app = {
        _key: 'metastock_user',
        init: function () {
            let storage = {};

            try {
                storage = JSON.parse(localStorage.getItem(this._key));
            } catch (ignore) { }

            if (!storage) {
                this.store(defaults);
            }
        },
        getData: function (key) {
            let storage = this.retrieve();

            return storage[key];
        },
        hasData: function (key) {
            try {
                let storage = JSON.parse(localStorage.getItem(this._key));

                if (
                    'undefined' === typeof storage ||
                    'undefined' === typeof storage[key] ||
                    false === storage[key]
                ) {
                    return false;
                }

                if (storage[key].length) {
                    return storage[key].length;
                }

                for (let object_key in storage[key]) {
                    if (
                        'object' === typeof storage[key] &&
                        storage[key].hasOwnProperty(object_key) &&
                        (
                            'undefined' !== typeof storage[key][object_key]['id'] ||
                            storage[key][object_key]['id']
                        )
                    ) {
                        return true;
                    }
                }

                return false;
            } catch (err) {
                console.error('error in MetastockStorage.hasData', err);
            }

            return false;
        },
        hasLocationId: function () {
            try {
                let storage = JSON.parse(localStorage.getItem(this._key));

                if (
                    'undefined' === typeof storage ||
                    'undefined' === typeof storage['location_id'] ||
                    false === storage['location_id']
                ) {
                    return false;
                }

                if (Number(storage['location_id'])) {
                    return true;
                }
            } catch (err) {
                console.error('error in MetastockStorage.hasLocationId', err);
            }

            return false;
        },
        setData: function (key, data) {
            let storage = this.retrieve();

            storage[key] = data;

            return this.store(storage);
        },
        retrieve: function () {
            let storage = {};

            try {
                storage = JSON.parse(localStorage.getItem(this._key));

                if (!storage) {
                    storage = {};
                }
            } catch (ignore) { }

            for (let key in defaults) {
                if (
                    defaults.hasOwnProperty(key) &&
                    'undefined' === typeof storage[key]
                ) {
                    storage[key] = defaults[key];
                }
            }

            return storage;
        },
        store: function (data) {
            try {
                localStorage.setItem(this._key, JSON.stringify(data));
            } catch (error) {
                console.error(error);
                return false;
            }

            return true;
        }
    };

    storage_app.init();

    return storage_app;
})();
MetastockApiFunctions = {
    pagination: 24,
    extractApiResponse: function (t) {
        let e = [];
        return t.destinationAddresses.forEach(((a, n) => {
            if (t.rows[0].elements[n].status == 'OK') {
                e.push({
                    address: a,
                    distance: t.rows[0].elements[n].distance.value,
                    distance_text: t.rows[0].elements[n].distance.text,
                    duration: t.rows[0].elements[n].duration.text
                })
            }
        })), e
    },
    combineResults: function (t) {
        let e = [];
        return t.forEach((t => {
            t.forEach((t => {
                e.push(t)
            }))
        })), e.sort(((t, e) => t.distance < e.distance ? -1 : e.distance < t.distance ? 1 : 0)), e
    },
    getLocationsFromResponse(t) {
        let e = [];
        return t.forEach((t => {
            let a = t.address,
                n = t.distance_text,
                o = Number(t.distance),
                i = t.duration,
                s = MetastockLocations.findByAddress(a).location;
            void 0 !== s && (s.distance = n, s.travel_time = i, e.push({
                id: s.id,
                meters: o,
                miles: n,
                distance: n,
                travel_time: i
            }))
        })), e
    },
    getPagedLocations: function () {
        let t = [];
        if (MetastockLocations.each((e => {
            t.push(MetastockLocations.oneLineAddress(e))
        })), t.length <= this.pagination) return [t];
        let e = 0,
            a = 0,
            n = [];
        return t.forEach((t => {
            n[a] ? n[a].push(t) : n.push([t]), ++e === this.pagination && (a++, e = 0)
        })), n
    }
},
    MetastockGoogleApi = function (t) {
        return {
            name: "MetastockGoogleApi",
            api_key: t,
            init: function () {
                if (this.api_key.length) {
                    var e = document.createElement("script");
                    e.src = "https://maps.googleapis.com/maps/api/js?callback=init_metastock_distance_api&key=" + t, e.async = !0, document.head.appendChild(e)
                }
            },
            fetch: function (t, e) {
                let a = MetastockApiFunctions.getPagedLocations(),
                    n = new google.maps.DistanceMatrixService,
                    o = [],
                    i = 0,
                    s = function (t, e) {
                        if ("OK" != e) throw new Error("Network response was not OK: " + e);
                        o.push(MetastockApiFunctions.extractApiResponse(t)), i++
                    };
                a.forEach((e => {
                    n.getDistanceMatrix({
                        origins: [t],
                        destinations: e,
                        travelMode: "DRIVING",
                        unitSystem: google.maps.UnitSystem.IMPERIAL,
                        avoidHighways: !1,
                        avoidTolls: !0
                    }, s)
                }));
                let c = setInterval((() => {
                    if (i >= a.length) {
                        let t = MetastockApiFunctions.combineResults(o),
                            a = MetastockApiFunctions.getLocationsFromResponse(t);
                        MetastockStorage.setData("locations_distances", a), MetastockFlyout.renderLocationList(), clearInterval(c), void 0 !== e && e(t);
                    }
                }), 200)
            }
        }
    },
    MetastockLocations = {
        setSelectedToFirstInList: !1,
        checkForLocations: function () {
            if ("undefined" == typeof metastock_locations) throw new Error("Could not find Metastock locations. Did you include them?");
            let t = MetastockStorage.getData("location_id");
            for (let e = 0; e < metastock_locations.length; e++) {
                let a = metastock_locations[e],
                    n = !1;
                (!t && 0 === e || t == a.id) && (n = !0), metastock_locations[e].distance = !1, metastock_locations[e].meters = !1, metastock_locations[e].travel_time = !1, metastock_locations[e].selected = n
            }
        },
        createHash: function (t) {
            return t.replace(/avenue/gi, "ave").replace(/apartment/gi, "apt").replace(/boulevard/gi, "blvd").replace(/center/gi, "ctr").replace(/circle/gi, "cir").replace(/court/gi, "ct").replace(/drive/gi, "dr").replace(/expressway/gi, "expy").replace(/heights/gi, "hts").replace(/highway/gi, "hwy").replace(/island/gi, "is").replace(/junction/gi, "jct").replace(/lake/gi, "lk").replace(/lane/gi, "ln").replace(/mountain/gi, "mtn").replace(/parkway/gi, "pkwy").replace(/place/gi, "pl").replace(/plaza/gi, "plz").replace(/ridge/gi, "rdg").replace(/road/gi, "rd").replace(/room/gi, "rm").replace(/square/gi, "sq").replace(/station/gi, "sta").replace(/street/gi, "st").replace(/suite/gi, "ste").replace(/terrace/gi, "ter").replace(/trail/gi, "trl").replace(/turnpike/gi, "tpke").replace(/valley/gi, "vly").replace(/northeast/gi, "ne").replace(/northwest/gi, "nw").replace(/southeast/gi, "se").replace(/southwest/gi, "sw").replace(/east/gi, "e").replace(/north/gi, "n").replace(/south/gi, "s").replace(/west/gi, "w").replace(/ |\.|,|\#|-/g, "").toLowerCase()
        },
        getSortedLocations: function () {
            let t = MetastockStorage.getData("locations_distances");
            if (!t || !t.length) return this.getWithSelectedFirst();
            this.checkForLocations();
            let e = [],
                a = this.findById(MetastockStorage.getData("location_id"));
            t.sort(((t, e) => void 0 === t.meters ? 1 : void 0 === e.meters || t.meters < e.meters ? -1 : 0));
            for (let n = 0; n < t.length; n++) {
                let o = t[n];
                if (a && this.setSelectedToFirstInList && o.id == a.id) continue;
                let i = o.id;
                metastock_locations.forEach((t => {
                    i == t.id && (t.distance = o.distance, t.meters = o.meters, t.travel_time = o.travel_time, e.push(t))
                }))
            }
            return e
        },
        getSelected: function () {
            this.checkForLocations();
            let t = MetastockStorage.getData("location_id");
            if (!t) {
                let t = this.first();
                return MetastockStorage.setData("location_id", t.id), t
            }
            return this.findById(t)
        },
        getWithSelectedFirst: function () {
            this.checkForLocations();
            let t = MetastockStorage.getData("location_id");
            if (!t) return metastock_locations;
            let e = [],
                a = this.findById(t);
            return a && (a.selected = !0, e.push(a)), this.each((t => {
                a && t.id == a.id || (t.selected = !1, e.push(t))
            })), e
        },
        each: function (t) {
            this.checkForLocations();
            for (let e = 0; metastock_locations.length > e; e++) t(metastock_locations[e], e)
        },
        findByAddress: function (t) {
            return this.checkForLocations(), t = t.replace(", USA", ""), t = MetastockLocations.createHash(t), this.find((e => {
                let a = MetastockLocations.createHash(this.oneLineAddress(e, ""));
                return -1 !== t.indexOf(a)
            }))
        },
        findById: function (t) {
            this.checkForLocations();
            let e = this.find((function (e) {
                return t == e.id
            }));
            return !1 !== e && e.location
        },
        findByLocation: function (t) {
            this.checkForLocations();
            let e = this.findById(t.id);
            return !!e && e.location
        },
        find: function (t) {
            this.checkForLocations();
            for (let e = 0; metastock_locations.length > e; e++) {
                let a = metastock_locations[e];
                if (t(a, e)) return {
                    index: e,
                    location: a
                }
            }
            return !1
        },
        first: function () {
            return this.checkForLocations(), this.find((() => !0)).location
        },
        oneLineAddress: function (t, e) {
            void 0 === e && (e = " ");
            let a = t.address + e;
            return t.address2 && (a += t.address2 + e), a += t.city + e + t.province_code + e + t.zip, a
        },
        standardize: function (t) {
            for (let e = 0; e < t.length; e++) t[e] = this.standardizeLocation(t[e]);
            return t
        },
        standardizeLocation: function (t) {
            return void 0 === t.address && (t.address = t.address1), void 0 === t.state && (t.state = t.province_code), t
        }
    },
    metastockInventoryWarningTitle = function (t) {
        if (void 0 !== t.title && t.title.length) return t.title;
        let e = "",
            a = !1;
        return void 0 !== t.product_title && t.product_title.length && (a = !0, e = t.product_title), void 0 !== t.variant_title && "Default Title" !== t.variant_title && (a ? e += ` - ${t.variant_title}` : e = t.variant_title), e
    },
    MetastockExactInventoryStrategy = function () {
        return {
            name: "exact",
            quantityIsAcceptable: function (t, e) {
                return !isNaN(t) && t >= e
            },
            warningMessage: function (t) {
                let e = metastockInventoryWarningTitle(t),
                    a = "";
                void 0 !== e && e && (a += `for the product, "${e}",`);
                let n = t.requested_quantity,
                    o = 0;
                return void 0 !== t.on_hand && (o = t.on_hand), `\n                The requested quantity of ${n} \n                ${a}\n                exceeds the availability of ${o}\n            `
            }
        }
    },
    MetastockRangesInventoryStrategy = function () {
        return {
            name: "ranges",
            quantityIsAcceptable: function (t, e) {
                return !isNaN(t) && (t > 0 || 0 == e)
            },
            warningMessage: function (t) {
                return `Cannot fulfill out-of-stock product, "${metastockInventoryWarningTitle(t)}"`
            }
        }
    };
let MetastockInventoryStrategy = (function (strategy) {
    return {
        strategy: strategy,
        /** @return object */
        checkCart: function (cart_data) {
            console.log("🔎 Debug: Entering checkCart function");
            let warnings = { length: 0, items: [], map: {} };

            let location = MetastockLocations.getSelected();
            console.log("📍 Checking cart for location:", location);

            if (location.offers_pickup === 0 && location.offers_delivery === 0) {
                warnings.length += 1;
                warnings.items.push("Location does not offer online ordering");
                warnings.map["location"] = "Location does not offer online ordering";
            } else {
                let location_variants = cart_data.getLocationInventoryData(location.id);
                console.log("🛒 Location inventory data:", location_variants);

                for (const product_id in location_variants) {
                    for (const variant_id in location_variants[product_id]) {
                        let variant = location_variants[product_id][variant_id];
                        console.log(`🔎 Checking product ${product_id}, variant ${variant_id}`, variant);

                        let cartRow = document.querySelector(`[data-metastock-variant="${variant_id}"]`);

                        // Fallback: If no cartRow found, assume the item should still be checked
                        if (!cartRow) {
                            console.warn(`⛔ No cart row found for variant ${variant_id}. Falling back to inventory-based check.`);
                            warnings = this.checkItem(warnings, variant);
                            continue;
                        }

                        // Ensure we have a valid template suffix, defaulting to "default"
                        let templateSuffix = cartRow.dataset.templateSuffix || "default";
                        console.log(`🛠 Found cart row: ${variant_id}, Template Suffix: ${templateSuffix}`);

                        // **Ignore "no-metastock" products**
                        if (templateSuffix === "no-metastock") {
                            console.log(`🚫 Skipping variant ${variant_id} due to no-metastock template`);
                            continue;
                        }

                        // Proceed with inventory validation for non-excluded products
                        warnings = this.checkItem(warnings, variant);
                    }
                }
            }

            console.log("📋 Final Warnings Object:", warnings);
            return warnings;
        },
        checkItem: function (warnings, item_data) {
            let requested = Number(item_data.requested_quantity);
            let on_hand = Number(item_data.on_hand ?? 0);

            console.log(`🛒 Checking inventory: Requested: ${requested}, On Hand: ${on_hand}`);

            if (this.quantityIsAcceptable(on_hand, requested)) {
                console.log("✅ Quantity is acceptable, skipping warning.");
                return warnings;
            }

            let message = this.strategy.warningMessage(item_data);

            warnings.length++;
            warnings.items.push(message);

            let variant_id = item_data.variant_id;
            warnings.map[variant_id] = message;

            console.log(`🚨 Warning created for variant ${variant_id}: ${message}`);
            return warnings;
        },
        quantityIsAcceptable: function (on_hand_quantity, requested_quantity) {
            return this.strategy.quantityIsAcceptable(
                on_hand_quantity,
                requested_quantity
            );
        }
    };
});

MetastockInventory = {
    allow_add_when_quantity_exceeded: !1,
    disable_add_when_quantity_exceeded: !0,
    quantity: 0,
    inventory_levels: !1,
    current_variant_id: !1,
    html_add_to_cart_button: !1,
    html_buy_now_button: !1,
    html_quantity_input: !1,
    pdp_location_display_type: "selected_location",
    template_store_availability: !1,
    cached_url: !1,
    init: function (t, e, a, n) {
        if (void 0 === t || !document.getElementById("js-store-availability")) return !1;
        if (this.current_variant_id = t, void 0 !== n && (this.pdp_location_display_type = n), "undefined" == typeof metastock_inventory) throw new Error("Could not find inventory. Did you include the metastock_inventory variable?");
        this.inventory_levels = metastock_inventory;
        let o = this;
        this.template_store_availability = new MetastockTemplate("js-store-availability", metastock_template_store_availability, "Store availability message"), this.disable_add_when_quantity_exceeded = e, this.allow_add_when_quantity_exceeded = !e, this.checkForAddToCartButton(a), o.html_quantity_input = document.querySelector("input[name=quantity]"), o.html_quantity_input && (o.quantity = parseInt(o.html_quantity_input.value), o.html_quantity_input.addEventListener("change", (function (t) {
            o.quantity = parseInt(t.target.value), o.ensureInventoryLevel(), o.renderStoreAvailability()
        })));

        // Add event listeners to the plus and minus buttons
        var quantityMinusButton = document.querySelector('[data-quantity-minus]');
        var quantityPlusButton = document.querySelector('[data-quantity-plus]');

        if (quantityMinusButton) {
            quantityMinusButton.addEventListener('click', function () {
                let newValue = parseInt(o.html_quantity_input.value);
                o.html_quantity_input.value = newValue;
                o.quantity = newValue;
                o.ensureInventoryLevel();
                o.renderStoreAvailability();
            });
        }

        if (quantityPlusButton) {
            quantityPlusButton.addEventListener('click', function () {
                let newValue = parseInt(o.html_quantity_input.value);
                o.html_quantity_input.value = newValue;
                o.quantity = newValue;
                o.ensureInventoryLevel();
                o.renderStoreAvailability();
            });
        }

        o.ensureInventoryLevel(), o.renderStoreAvailability(), o.cached_url = window.location.search, setInterval(o.checkVariantQueryString, 500), document.addEventListener("MetastockLocationUpdated", (() => {
            o.ensureInventoryLevel(), o.renderStoreAvailability()
        }))
    },
    checkForAddToCartButton: function (t) {
        t && "" !== t || (t = "#addToCart-product-template"), this.html_add_to_cart_button = document.querySelector(t), this.html_add_to_cart_button || (this.html_add_to_cart_button = document.querySelector("button[name=add]"));
        let e = document.getElementsByClassName("shopify-payment-button__button--unbranded")[0];
        void 0 !== e && (this.html_buy_now_button = e)
    },
    disableAddToCart: function () {
        if (this.html_add_to_cart_button) {
            this.html_add_to_cart_button
                .classList.add('product-detail-btn-disabled');

            this.html_add_to_cart_button
                .classList.add('metastock-button-disabled');

            this.html_add_to_cart_button.disabled = true;
        }

        if (this.html_buy_now_button) {
            this.html_buy_now_button.classList.add('buy-now-btns-disabled')

            this.html_buy_now_button.classList.add('metastock-button-disabled');

            this.html_buy_now_button.disabled = true;
        }
    },
    enableAddToCart: function () {
        if (this.html_add_to_cart_button) {
            this.html_add_to_cart_button
                .classList.remove('product-detail-btn-disabled');

            this.html_add_to_cart_button
                .classList.remove('metastock-button-disabled');

            this.html_add_to_cart_button.disabled = false;
        }

        if (this.html_buy_now_button) {
            this.html_buy_now_button
                .classList.remove('buy-now-btns-disabled');

            this.html_buy_now_button
                .classList.remove('metastock-button-disabled');

            this.html_buy_now_button.disabled = false;
        }
    },
    ensureInventoryLevel: function () {
        let location_id = MetastockStorage.getData('location_id');
        // Robert added so we can get selected location pickup and delivery settings
        let location = MetastockLocations.findById(location_id);

        let inventory = this.getInventoryForLocation(location_id);

        if (
            this.html_quantity_input &&
            !metastock_inventory_strategy.quantityIsAcceptable(
                parseInt(inventory),
                this.quantity
            )
        ) {
            this.disableAddToCart();
            return false;
        }

        // ✅ Retrieve metastockSettings from app embed
        let enablePickup = window.metastockSettings?.enable_pickup_locations ?? false;
        let enableDelivery = window.metastockSettings?.enable_delivery_locations ?? false;

        // ROBERT ADD PICKUP AND DELIVERY CONDITIONS
        if (enablePickup && enableDelivery) {
            if (location.offers_pickup == 0 && location.offers_delivery == 0) {
                this.disableAddToCart();
                return false;
            }
        } else if (enablePickup && !enableDelivery) {
            if (location.offers_pickup == 0) {
                this.disableAddToCart();
                return false;
            }
        } else if (!enablePickup && enableDelivery) {
            if (location.offers_delivery == 0) {
                this.disableAddToCart();
                return false;
            }
        }


        this.enableAddToCart();
        return true;
    },
    hasInventoryLevels: function () {
        return this.inventory_levels;
    },
    getInventoryForLocation: function (location_id) {
        if (
            !this.current_variant_id ||
            'undefined' === typeof this.inventory_levels[this.current_variant_id]
        ) {
            return false;
        }

        let inventories = this.inventory_levels[this.current_variant_id];
        for (let i = 0; i < inventories.length; i++) {
            let inventory = inventories[i];

            if (location_id == inventory.location_id) {
                return parseInt(inventory.available);
            }
        }

        return false;
    },
    renderStoreAvailability: function () {
        "all_locations" === this.pdp_location_display_type ? this.renderAllStoreAvailability() : this.renderSelectedStoreAvailability()
    },
    renderAllStoreAvailability: function () {
        let t = {
            locations: MetastockFlyout.getLocationInventoryData(),
        };
        return this.template_store_availability.render(t)
    },
    renderSelectedStoreAvailability: function () {
        let location_id = MetastockStorage.getData('location_id');

        let location = MetastockLocations.findById(location_id);

        let data = {
            available: this.getInventoryForLocation(location_id),
            location: location.name,
            quantity: this.quantity,
            //Robert added pickup and delivery properties
            offers_pickup: location.offers_pickup,
            offers_delivery: location.offers_delivery,
        };

        return this.template_store_availability.render(data);
    },
    checkVariantQueryString: function () {
        window.location.search !== MetastockInventory.cached_url && (MetastockInventory.setVariantIdFromQueryString(), MetastockInventory.ensureInventoryLevel(), MetastockInventory.renderStoreAvailability(), MetastockInventory.cached_url = window.location.search, document.dispatchEvent(new CustomEvent("MetastockVariantChanged", {
            detail: MetastockInventory.current_variant_id
        })))
    },
    setVariantIdFromQueryString: function () {
        let t = new URLSearchParams(window.location.search).get("variant");
        t && (MetastockInventory.current_variant_id = t)
    }
};

let MetastockFlyout = (function () {
    return {
        is_open: false,
        html_flyout: false,
        html_location_list: false,
        template_location_list: false,
        init: function () {
            let self = this;

            self.html_flyout = document.getElementById(
                'js-metastock-flyout'
            );

            self.template_location_list = new MetastockTemplate(
                'js-metastock-location-list',
                metastock_template_location_list,
                'Location flyout menu'
            );

            self.renderLocationList();

            document.addEventListener('MetastockVariantChanged', () => {
                MetastockFlyout.renderLocationList();
            });

            document.addEventListener('MetastockLocationUpdated', () => {
                MetastockFlyout.renderLocationList();
            });
        },
        close: function () {
            this.is_open = false;

            this.html_flyout.classList.remove('enabled-shift');
        },
        open: function () {
            this.is_open = true;

            this.html_flyout.classList.add('enabled-shift');
        },
        toggle: function () {
            if (this.is_open) {
                this.close();
            } else {
                this.open();
            }
        },
        getLocationInventoryData: function () {
            let locations = MetastockLocations.getSortedLocations();

            let has_inventory = MetastockInventory.hasInventoryLevels();

            for (let i = 0; i < locations.length; i++) {
                let location = locations[i];

                locations[i].has_inventory = has_inventory;

                if (has_inventory) {
                    locations[i].available = MetastockInventory.getInventoryForLocation(
                        location.id
                    );
                }
            }

            return locations;
        },
        renderLocationList: function () {
            let data = { locations: this.getLocationInventoryData() };

            data.locations = [
                ...new Map(
                    data.locations.map(loc => [loc.id, loc])
                ).values()
            ];

            return this.template_location_list.render(data);
        },
        selectLocation: function (location_id) {
            MetastockStorage.setData('location_id', location_id);
            document.dispatchEvent(new CustomEvent('MetastockLocationUpdated', { detail: location_id }));

            setTimeout(() => {
                MetastockCartData.init(metastock_cart_data); // Refresh cart data
                MetastockCart.ensureValidCart(); // Ensure all warnings are updated
            }, 150);
            this.renderLocationList();
        }
    };
})();

let MetastockLocationDisplay = (function () {
    return {
        html_names: false,
        html_addresses: false,
        init: function () {
            this.html_names = document.querySelectorAll('.js-metastock-store-name');
            this.html_addresses = document.querySelectorAll('.js-metastock-store-address');

            this.setLocationName();

            let self = this;

            document.addEventListener('MetastockLocationUpdated', () => {
                self.setLocationName();
            });

            document.querySelectorAll('.metastock-selected-location-container').forEach(function (block) {
                block.style.display = '';
            });
        },
        setLocationName: function () {
            if (!this.html_names) {
                return;
            }

            let location = MetastockLocations.getSelected();

            this.html_names.forEach((html_name) => {
                html_name.innerHTML = location.name;
            });

            this.html_addresses.forEach((html_address) => {
                html_address.innerHTML = location.address;
            });
        }
    };
})();

let MetastockGeolocation = (function () {
    return {
        html_form: false,
        html_address_input: false,
        html_clear_address_button: false,
        api: false,
        init: function (api) {
            this.html_form = document.getElementById(
                'metastock-form-address'
            );

            if (!this.html_form) {
                console.debug(
                    'Could not find Metastock geolocation form. Was it included?'
                );

                return false;
            }

            if ('undefined' === typeof api) {
                if ('undefined' === window.MetastockNmrApi) {
                    console.debug('Could not find a suitable Api to use');

                    return false;
                }

                api = new MetastockNmrApi();
            }


            this.api = api;
            if ('undefined' !== typeof this.api.init) {
                this.api.init();
            }

            document.getElementById('metastock-geo-form-container').style.display = '';

            this.html_clear_address_button = document.getElementById(
                'js-metastock-clear-address'
            );

            let address = MetastockStorage.getData('address');

            this.html_address_input = document.getElementById(
                'metastock-address-input'
            );

            if (address && this.html_address_input) {
                this.html_address_input.value = address;
            }

            this.html_form.addEventListener("submit", this.searchAddress);

            this.html_clear_address_button.addEventListener(
                'click',
                this.clearAddress
            );
        },
        clearAddress: function (event) {
            event.preventDefault();

            document.getElementById(
                'metastock-address-input'
            ).value = '';

            MetastockStorage.setData('address', false);
            MetastockStorage.setData('locations_distances', false);

            document.dispatchEvent(new CustomEvent('MetastockLocationUpdated'));
        },
        searchAddress: function (event) {
            event.preventDefault();

            let unencoded_address = document.getElementById(
                'metastock-address-input'
            ).value;

            let retrieved_address = MetastockStorage.getData('address');

            if (
                retrieved_address && (
                    NaN === Number(retrieved_address) &&
                    retrieved_address.lowerCase == unencoded_address.lowerCase
                ) || (
                    Number(retrieved_address) === Number(unencoded_address)
                )
            ) {
                /* If we have a stored address, compare it to the submitted one.
                 * If they are numbers (ZIPs) and they match, no point fetching
                 * data from the api, since it should be the same.
                 * Same goes for actual addresses (converting a non-numeric
                 * string to a number produces NaN). */
                return true;
            }

            MetastockStorage.setData('address', unencoded_address);

            let result = MetastockGeolocation.api.fetch(unencoded_address);

            if (
                'undefined' === typeof result ||
                'undefined' === typeof result.then
            ) {
                if (false === result) {
                    return false;
                }

                MetastockGeolocation.updateLocations(result);

                return;
            }

            result.then((sorted_locations) => {
                if (false === sorted_locations) {
                    return false;
                }

                MetastockGeolocation.updateLocations(sorted_locations);
            }).catch(error => {
                console.error('There has been a problem with your fetch operation:', error);

                alert(
                    'There was an issue retrieving distance information. ' +
                    'Please try again soon'
                );
            });
        },
        updateLocations: function (sorted_locations) {
            MetastockStorage.setData('locations_distances', sorted_locations);

            document.dispatchEvent(new CustomEvent('MetastockLocationUpdated'));
        }
    };
})();



let MetastockCartData = (function () {
    let data = {
        locations: {},
        products: {},
        variant_map: {},
        addProductTitle: function (product_id, variant_data) {
            if (variant_data.product_title.length) {
                this.products[product_id] = variant_data.product_title;
                return;
            }

            let product_title;
            if (
                'undefined' !== typeof variant_data.variant_title &&
                variant_data.variant_title.length
            ) {
                product_title = variant_data.title.replace(
                    ` - ${variant_data.variant_title}`,
                    ''
                );

                this.products[product_id] = product_title;
            }

            if (
                'undefined' !== typeof variant_data.title &&
                variant_data.title.length
            ) {
                this.products[product_id] = variant_data.title;
            }
        },
        ensureProductData: function () {
            for (let location_id in this.locations) {
                for (let product_id in this.locations[location_id]) {
                    let product_title = this.products[product_id];

                    for (let variant_id in this.locations[location_id][product_id]) {
                        let variant = this.locations[location_id][product_id][variant_id];

                        if ('undefined' === typeof variant.product_title) {
                            variant.product_title = product_title;
                            variant.product_id = product_id;

                            this.locations[location_id][product_id][variant_id] = variant;
                        }
                    }
                }
            }
        }
    };

    return {
        init: function (cart_data) {
            let locations = MetastockLocations.getSortedLocations();

            locations.forEach(location => {
                data.locations[location.id] = {};
            });

            let selected_location = MetastockLocations.getSelected();

            if (cart_data != false) {
                cart_data.forEach(item => {
                    if (
                        'undefined' !== typeof item.product_title &&
                        item.product_title.length
                    ) {
                        data.products[item.product_id] = item.product_title;
                    }

                    item.inventory.forEach((variant, index) => {
                        if (0 === index) {
                            variant.location_id = selected_location.id;
                        }

                        //Robert removed this on 8/24 because cart items not registered at a location were throwing an error in the console. 
                        // data.locations[variant.location_id][item.product_id] = {};

                        // data.locations[variant.location_id][item.product_id][variant.variant_id] = {};

                        this.add(variant, false);
                    });
                });
            }

            data.ensureProductData();
        },
        add: function (variant_data, ensure_product_data) {
            if ('undefined' === typeof ensure_product_data) {
                ensure_product_data = true;
            }

            if (
                'undefined' === typeof variant_data.location_id ||
                !variant_data.location_id ||
                'undefined' === typeof variant_data.variant_id ||
                !variant_data.variant_id ||
                'undefined' === typeof variant_data.product_id ||
                !variant_data.product_id
            ) {
                return;
            }

            let product_id = variant_data.product_id;
            let variant_id = variant_data.variant_id;
            let location_id = variant_data.location_id;

            if (!data.products[product_id]) {
                data.addProductTitle(product_id, variant_data);
            }

            data.variant_map[variant_id] = product_id;

            if ('undefined' === typeof data.locations[location_id]) {
                data.locations[location_id] = {};
            }

            if ('undefined' === typeof data.locations[location_id][product_id]) {
                data.locations[location_id][product_id] = {};
            }

            if (variant_id) {
                data.locations[location_id][product_id][variant_id] = variant_data;
            }

            if (ensure_product_data) {
                data.ensureProductData();

                if (variant_data.requested_quantity) {
                    this.updateRequestedQuantity(
                        variant_id,
                        variant_data.requested_quantity
                    );
                }
            }
        },
        get: function () {
            return data;
        },
        getLocationInventoryData: function (location_id) {
            if ('undefined' === data.locations[location_id]) {
                return {};
            }

            return data.locations[location_id];
        },
        getVariantInventoryData: function (location_id, product_id, variant_id) {
            if ('undefined' !== typeof data.locations[location_id][product_id][variant_id]) {
                return data.locations[location_id][product_id][variant_id];
            }

            return {
                product_id: product_id,
                variant_id: variant_id,
                location_id: location_id,
                on_hand: 0,
            };
        },
        replace: function (item) {
            let location_id = item.location_id;
            let product_id = item.product_id;
            let variant_id = item.variant_id;

            data.locations[location_id][product_id][variant_id] = item;
        },
        updateRequestedQuantity: function (variant_id, quantity) {
            for (const location_id in data.locations) {
                let product_id = data.variant_map[variant_id];

                let variant_id = product_id;

                let inventory = this.getVariantInventoryData(location_id, product_id, variant_id);

                inventory.requested_quantity = quantity;

                data.locations[location_id][product_id][variant_id] = inventory;
            }
        },
    };
})();
let MetastockCart = (function () {
    return {
        cart_data: {},
        inputs_data: [],
        allow_disable_checkout: false,
        inventory_strategy: null,
        html_checkout_buttons: false,
        locations: false,
        init: function (
            metastock_cart_data,
            inventory_strategy,
            checkout_selector
        ) {
            this.cart_data = metastock_cart_data;

            this.inventory_strategy = inventory_strategy;

            if ('undefined' !== typeof checkout_selector && checkout_selector) {
                this.allow_disable_checkout = true;

                this.html_checkout_buttons = document.querySelectorAll(
                    checkout_selector
                );

                if (null === this.html_checkout_buttons) {
                    console.info(
                        "The provided css selector, " + checkout_selector +
                        ", could not be found on the page. Are you sure it's correct?"
                    );
                }
            }

            this.ensureValidCart();

            if (
                document.querySelectorAll("input[name='updates[]']").length &&
                // ROBERT: Customized the class below to accomodate SouthernStates theme. It's the + and - button quantity selectors
                document.querySelectorAll('.quantity-selector__button').length
            ) {
                this.setVariantIdDataForInputs();
                this.setUpQuantityUpdateInterval();
            }

            let self = this;

            document.addEventListener('MetastockLocationUpdated', () => {
                self.ensureValidCart();
            });

            // Robert Customization: Add event listeners to quantity input changes
            document.querySelectorAll("input[name='updates[]']").forEach(function (input) {
                input.addEventListener('change', function () {
                    //ROBERT: EnsureValidCart does not trigger the warnings. setUpQauntityUpdateInterval does. Removed the timer and triggering setUpQuantityInterval instead. 
                    self.setVariantIdDataForInputs();
                    self.setUpQuantityUpdateInterval();
                });
                input.addEventListener('input', function () {
                    //ROBERT: EnsureValidCart does not trigger the warnings. setUpQauntityUpdateInterval does. Removed the timer and triggering setUpQuantityInterval instead. 
                    self.setVariantIdDataForInputs();
                    self.setUpQuantityUpdateInterval();
                });
            });

            /*  Robert Customization: Add event listeners to the plus and minus buttons
            UPDATE: Might not be necessary with Interval running anways
            */
            document.querySelectorAll('.quantity-selector__button').forEach(function (button) {
                button.addEventListener('click', function () {
                    //ROBERT: EnsureValidCart does not trigger the warnings. setUpQauntityUpdateInterval does. Removed the timer and triggering setUpQuantityInterval instead. 
                    self.setVariantIdDataForInputs();
                    self.setUpQuantityUpdateInterval();
                    self.ensureValidCart();
                });
            });


        },
        ensureValidCart: function () {

            if (!this.cart_data) {

                return false;
            }

            this.clearWarnings();

            let warnings = this.inventory_strategy != null ? this.inventory_strategy.checkCart(this.cart_data) : null;

            if (warnings != null && !warnings.length) {
                this.enableCheckout();
                return false;
            }


            this.disableCheckout();

            this.showGlobalCartWarning(warnings);

            this.showCartItemWarnings(warnings);
        },
        clearWarnings: function () {
            let warning_container = document
                .getElementById('js-cart-warning');

            if (warning_container != null) {
                warning_container.innerHTML = '';
                warning_container.classList
                    .remove('metastock-cart-quantity-warning');

                let warning_containers = document.querySelectorAll(
                    '.metastock-cart-item-warning'
                );

                if (!warning_containers || !warning_containers.length) {
                    return;
                }

                warning_containers.forEach((row) => {
                    row.innerHTML = '';
                });
            }
        },
        showGlobalCartWarning: function (warnings) {
            let selected_location = MetastockLocations.getSelected();

            let warning_container = document
                .getElementById('js-cart-warning');

            if (warnings != null && warnings.length) {
                warning_container.innerHTML = `
                    <div class="metastock-cart-warning-wrap">
                        <p class="metastock-cart-warning-message">
                            Please adjust quantities in your cart
                            at the store: ${selected_location.name}
                        </p>
                        <ul class="metastock-cart-warning-list">
                            <li>${warnings.items.join('</li><li>')}</li>
                        </ul>
                    </div>
                `;
            }

            if (warning_container && warning_container.innerHTML.length) {
                warning_container.classList
                    .add('metastock-cart-quantity-warning');
            }
        },
        showCartItemWarnings: function (warnings) {
            let warning_containers = document.querySelectorAll(
                '.metastock-cart-item-warning'
            );

            if (!warning_containers || !warning_containers.length) {
                return;
            }

            let selected_location = MetastockLocations.getSelected();

            for (const variant_id in warnings.map) {
                if (warnings.map.hasOwnProperty(variant_id)) {
                    let message = warnings.map[variant_id];

                    let cart_warning_container = document.getElementById(
                        `js-cart-warning-${variant_id}`
                    );

                    this.addWarningElementToCartItemRow(
                        cart_warning_container,
                        selected_location,
                        message
                    );
                }
            }
        },
        setVariantIdDataForInputs: function () {
            let self = this;
            /* ROBERT: 
              1.) Changed buttons to items variable reference. 
              2.) Added metastock-cart-item as a class on cart item loop. 
              3.) Removed all of the sibling traversing code and replace with let variant_id = item.dataset.metastockVariant; and self.inputs_data[variant_id] = index; refactoring
              4.) Added data-metastock-variant="{{ item.variant_id }}" to cart item loop, same <li> element in this instance as metastock-cart-item class addition
            */
            let items = document.querySelectorAll('.metastock-cart-item');

            items.forEach(function (item, index) {
                let variant_id = item.dataset.metastockVariant;
                self.inputs_data[variant_id] = index;
            });
        },
        setUpQuantityUpdateInterval: function () {
            let self = this;

            return setInterval(function () {
                let has_changes = false;

                let inputs = document.querySelectorAll(
                    "input[name='updates[]']"
                );

                let selected_location = MetastockLocations.getSelected();
                let selected_inventory = MetastockCartData.getLocationInventoryData(selected_location.id);

                for (let product_id in selected_inventory) {
                    for (let variant_id in selected_inventory[product_id]) {
                        let item_data = selected_inventory[product_id][variant_id];

                        let expected_index = self.inputs_data[variant_id];

                        let still_in_cart = false;
                        inputs.forEach(input => {
                            let input_index = input.dataset.index;

                            if (expected_index != input_index) {
                                return;
                            }

                            let quantity = parseInt(input.value);

                            if (item_data.variant_id == variant_id) {
                                still_in_cart = true;

                                if (parseInt(item_data.requested_quantity) !== quantity) {
                                    has_changes = true;
                                    item_data.requested_quantity = quantity;
                                    MetastockCartData.replace(item_data);
                                }
                            }
                        });

                        if (!still_in_cart) {
                            has_changes = true;

                            MetastockCartData.updateRequestedQuantity(variant_id, 0);
                        }
                    }
                }

                if (has_changes) {
                    self.ensureValidCart();
                }
                // ROBERT: Removed the interval, now calling the function every time an event happens
            },);
        },
        addWarningElementToCartItemRow: function (
            cart_warning_container,
            selected_location,
            message
        ) {
            let store_name = selected_location.name;

            let warning_text = document.createElement('p');

            warning_text.innerHTML = `Please adjust the cart. ${message} at the store: ${store_name}`;

            cart_warning_container.append(warning_text);
            // Apply styling
            warning_text.classList.add('metastock-item-quantity-warning');
        },
        disableCheckout: function () {
            if (
                !this.allow_disable_checkout ||
                !this.html_checkout_buttons ||
                !this.html_checkout_buttons.length
            ) {
                return;
            }

            this.html_checkout_buttons.forEach(el => {
                el.classList.add('metastock-button-disabled');
                el.disabled = true;
            });
        },
        enableCheckout: function () {
            if (
                !this.allow_disable_checkout ||
                !this.html_checkout_buttons ||
                !this.html_checkout_buttons.length
            ) {
                return;
            }

            this.html_checkout_buttons.forEach(el => {
                el.classList.remove('metastock-button-disabled');
                el.disabled = false;
            });
        }
    };
})();
let Metastock = (function () {
    return {
        version: '1.02',
        init: function (options_object) {
            window.metastock_locations = window.metastock_locations || [];

            if (!MetastockStorage.hasLocationId()) {
                MetastockStorage.setData('location_id', MetastockLocations.first().id);
            }

            window.metastock_cart_data = window.metastock_cart_data || false;

            window.metastock_inventory = window.metastock_inventory || false;

            window.metastock_variant_id = window.metastock_variant_id || false;

            window.metastock_cart_data = window.metastock_cart_data || false;

            if (
                !metastock_variant_id &&
                document.getElementById('productSelect-product-template')
            ) {
                metastock_variant_id = document.querySelector(
                    '#productSelect-product-template option[selected=selected]'
                ).value;
            }

            let disable_add_button = true;
            if ('undefined' !== typeof options_object.disable_add_when_quantity_exceeded) {
                disable_add_button = options_object.disable_add_when_quantity_exceeded;
            }

            let add_button_selector = null;
            if ('undefined' !== typeof options_object.add_to_cart_selector) {
                add_button_selector = options_object.add_to_cart_selector;
            }

            let pdp_location_display_type = 'selected_location';
            if ('undefined' !== typeof options_object.pdp_location_display_type) {
                pdp_location_display_type = options_object.pdp_location_display_type;
            }

            let track_quantities = 'exact';
            let low_stock_max = 5;
            if ('undefined' !== typeof options_object.track_quantities) {
                track_quantities = options_object.track_quantities;

                if ('ranges' === track_quantities) {
                    if (
                        'undefined' === typeof options_object.range_allows_add ||
                        options_object.range_allows_add
                    ) {
                        disable_add_button = false;
                        add_button_selector = null;
                    }

                    if ('undefined' !== typeof options_object.low_stock_max) {
                        low_stock_max = options_object.low_stock_max;
                    }

                    Metastock_Templates.decide_available_quantity_line = function (
                        available,
                        quantity_selected
                    ) {
                        return Metastock_Templates.ranges_quantity(
                            available,
                            low_stock_max
                        );
                    }
                }
            }

            if ('exact' === track_quantities) {
                Metastock_Templates.decide_available_quantity_line = function (
                    available,
                    quantity_selected
                ) {
                    return Metastock_Templates.exact_quantity(
                        available,
                        quantity_selected
                    );
                }
            }

            if ('ranges' === track_quantities) {
                window.metastock_inventory_strategy = MetastockInventoryStrategy(
                    MetastockRangesInventoryStrategy()
                );
            } else {
                window.metastock_inventory_strategy = MetastockInventoryStrategy(
                    MetastockExactInventoryStrategy()
                );
            }

            MetastockInventory.init(
                metastock_variant_id,
                disable_add_button,
                add_button_selector,
                pdp_location_display_type
            );

            MetastockLocationDisplay.init();

            MetastockFlyout.init();

            if ('undefined' !== typeof options_object.api) {
                MetastockGeolocation.init(options_object.api);
            }

            let warning_wrap = document.getElementById('js-cart-warning');
            if (warning_wrap) {
                let selector = false;
                if (warning_wrap.dataset.checkoutSelector) {
                    selector = warning_wrap.dataset.checkoutSelector;
                }

                MetastockCartData.init(metastock_cart_data);

                MetastockCart.init(
                    MetastockCartData,
                    metastock_inventory_strategy,
                    selector
                );
            }

            // CUSTOM: To include location in out of stock form
            /*const currentStore = document.querySelector('.js-metastock-store-name').innerHTML;

            if (currentStore) {
                const form = document.querySelector('.product-back_in_stock #contact_form');

                if (form) {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = 'contact[location]';
                    input.value = currentStore;

                    form.appendChild(input);
                }
            }*/
        }
    };
})();

// CUSTOM: To include location in out of stock form
/*document.addEventListener('MetastockLocationUpdated', () => {
    setTimeout(() => {
        const locationInput = document.querySelector('.product-back_in_stock #contact_form input[name="contact[location]"]');

        if (locationInput) {
            const currentStore = document.querySelector('.js-metastock-store-name').innerHTML;

            if (currentStore) {
                locationInput.value = currentStore;
            }
        }
    }, 200);
});*/